const devConf = {
    passCode: "RRlwd%AX", // 账号密码
    serverUrl: "https://qa-default.collector.sgmlink.com:8443", //接口服务
    // templateUrl: "https://qa-default.collector.sgmlink.com:8443", //模版
    aid: "A00000138", // 应用id /用户名
    sid: "S00000278", // 数据模板 ID（sid）
    svid: "SV00000540", // 数据模板版本 ID （svid）
    projectId: "SAMA_06I85JB1" //项目id
}

const prodConf = {
    passCode: "69sRHRe%",
    serverUrl: "https://default.collector.sgmlink.com:8443", 
    //   templateUrl: "https://config.collector.sgmlink.com:8443",
    aid: "A00000063",
    sid: "S00000278",
    svid: "SV00000540",
    projectId: "SAMA_0DA8O62J"
}
console.log(process.env.VUE_APP_ENV,1111)
module.exports = process.env.VUE_APP_ENV == "production" ? prodConf  : devConf